import { Dictionary, identity, Identity } from "../common";

export const EVENT_SOURCE_REFINERS = {
  googleCalendarApiKey: String, // TODO: rename with no prefix?
  googleCalendarId: String,
  googleCalendarApiBase: String,
  // @ts-ignore
  extraParams: identity as Identity<Dictionary | (() => Dictionary)>,
};
